import {CheckVersionRequest} from './CheckVersionRequest';
import {CheckVersionResponse} from './CheckVersionResponse';
import {BaseService} from '@utex/base-api-sdk';


export class MobileApplicationVersionService extends BaseService {
    protected clientName: string = 'MobileApplicationVersionService'
    
    checkVersion = this.createRest<CheckVersionResponse,CheckVersionRequest>('/rest/grpc/com.unitedtraders.luna.mobilegateway.version.MobileApplicationVersionService.checkVersion',false,'schema.json#/properties/checkVersionRequest','schema.json#/properties/checkVersionResponse','MobileApplicationVersionService/checkVersion');

}